export class ModelNotificationEvent {
    constructor(target) {
        this.target = target;
    }
}
//# sourceMappingURL=ModelNotificationEvent.js.map